<template>
  <article class="info-section elr-container-full">
    <div class="elr-row">
      <div class="elr-col-full">
        <section v-if="grouping">
          <div class="grouping-details">
            <div class="info-section-header">
              <div class="group-heading">
                <h1 class="info-section-heading">{{grouping.name}}</h1>
                <p class="info-section-description" v-if="grouping.description">{{grouping.description}}</p>
                <router-link :to="`/grouping/${grouping.sug}`">Back to {{grouping.name}}</router-link>
              </div>
              <GroupingDetails :grouping="grouping" />
            </div>
          </div>
        </section>
        <section v-if="related && related.length">
          <div class="groupings-list">
            <h3 class="info-section-heading">Related Groupings</h3>
            <list-item-grid>
              <GroupCard
                v-for="group in related"
                :key="group.id"
                :item="group"
              />
            </list-item-grid>
          </div>
        </section>
      </div>
    </div>
  </article>
</template>

<script>
import { slugify } from '../../utils/helpers';
import ListItemGrid from '../../components/ListItemGrid/ListItemGrid';
import GroupCard from '../../components/GroupCard/GroupCard';
import GroupingDetails from '../../components/GroupingDetails/GroupingDetails';

export default {
  name: 'Grouping',
  props: {
    slug: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      num: 12
    };
  },
  components: {
    GroupCard,
    GroupingDetails,
    ListItemGrid
  },
  mounted() {
    if (!this.grouping) {
      this.fetchGrouping(this.slug);
    }
  
    // infiniteScroll(() => {
    //   if (this.nextUrl) {
    //     this.onFetchMoreGroupings(this.slug, this.nextUrl);
    //   }
    // });
  },
  computed: {
    grouping() {
      const grouping = this.$store.getters['grouping/getBySlug'](this.slug)

      if (grouping) {
        return grouping;
      }

      return [];
    },
    related() {
      if (this.grouping) {
        if (this.grouping.related && this.grouping.related.items) {
          return this.grouping.related.items;
        }

        return [];
      }

      return [];
    }
  },
  methods: {
    slugify,
    fetchGrouping(slug) {
      this.$store.dispatch('grouping/FETCH', {
        slug,
        num: this.num
      });
    },
    onFetchMoreGroupings(slug, nextUrl) {
      if (nextUrl) {
        this.$store.dispatch('grouping/FETCH_MORE_RELATED', {
          slug,
          nextUrl
        });
      }
    }
  },
  watch: {
    $route() {
      this.grouping = {};
      this.groupings = [];
      this.fetchGrouping(this.slug);
    }
  }
};
</script>

<style scoped lang="scss">
@import '../../assets/sass/_config.scss';

.grouping-details-section {
  border-top: 1px solid $accent-color;
  border-bottom: 1px solid $accent-color;
  padding: 20px 0;
  margin-top: 20px;
}
</style>
